import React from 'react';
import ChapterLayout from './ChapterLayout';
import { chapterTemplates } from '../../data/chapterTemplates';
import { leadership, alumni, gallery } from '../../data/rochester';

const Rochester = () => (
  <ChapterLayout
    chapter={chapterTemplates.rochester}
    leadership={leadership}
    alumni={alumni}
    gallery={gallery}
  />
);

export default Rochester;
